import { Resource } from '../../../../http/resource/resource.model';
// tslint:disable: variable-name

export class StartApplyment extends Resource {
  steps: any;
  stage: any;
  process: any;
}

